import React from 'react';
import { FormattedMessage } from 'react-intl';
import { faQuestionCircle } from '@fortawesome/sharp-regular-svg-icons/faQuestionCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { messages } from './messages';
import style from './tooltip-style.module.css';

export const SurchargeTooltip = ({ creditCardProcessingFeePercentage }) => (
  <Tooltip position='top'>
    <TooltipContent>
      <FormattedMessage {...messages.surchargeTitle} values={{ percentage: creditCardProcessingFeePercentage.toFixed(1) }} />
    </TooltipContent>
    <div className={style['info-icon']}>
      <FontAwesomeIcon icon={faQuestionCircle} />
    </div>
  </Tooltip>
);
